module.exports = __webpack_public_path__ + "static/hero-image2-91eefb9e00d02449ad9b554c6032abb2.png";